import React, { Component } from "react";
import get from "lodash.get";
import {
  getEl,
  getEls,
  trackEvent,
  getParamFromQueryString,
} from "../../utils/app-helpers";
import Privacy from "./privacy";
import TermsMaui from "./terms-maui";
import TermsCancun from "./terms-cancun";
import TermsCancun2020 from "./terms-cancun2020";
import TermsCancun2021 from "./terms-cancun2021";
import TermsMaui2019 from "./terms-maui2019";
import TermsMaui2021 from "./terms-maui2021";
import TermsMaui2021V2 from "./terms-maui2021-v2";
import TermsKauai2019 from "./terms-kauai2019";
import TermsKauai2021 from "./terms-kauai2021";
import Gallery from "./gallery";
import Rooms from "./rooms";

export default class TabbedContent extends Component {
  state = { selectedKey: this.props.selectedKey };

  componentWillReceiveProps({ selectedKey }) {
    this.setState({ selectedKey });
  }

  componentDidMount() {
    if (this.props.willAnchor) {
      window.addEventListener("scroll", this.onScroll);
    }
  }

  componentWillUnmount() {
    if (this.props.willAnchor) {
      window.removeEventListener("scroll", this.onScroll);
    }
  }

  onScroll = () => {
    const el = getEl(".tabbed-content");
    if (typeof el === "undefined") return;
    const h1El = el.querySelector(".header h1");
    const h1Height = h1El ? h1El.offsetHeight : 0;
    const navHeight = get(this, "props.navHeight", 50);

    if (el.getBoundingClientRect().top < navHeight - h1Height) {
      el.classList.add("anchor-tabs");
    } else {
      el.classList.remove("anchor-tabs");
    }
  };

  selectTab = (selectedKey) => (e) => {
    if (typeof window === "undefined") return;
    const tabEl = e.target;
    const { replaceState, willAnchor } = this.props;
    const tabEls = getEls(".tabbed-content .tab");
    const contentsEl = getEl(".tabbed-content .contents");
    const contentEls = getEls(".tabbed-content .content");
    let selected;
    tabEls.forEach((el, index) => {
      if (el.innerText === tabEl.innerText) selected = index;
    });
    const selectedEl = contentEls[selected];
    const slug = tabEl.getAttribute("data-slug");

    contentsEl.style.minHeight = `${contentsEl.offsetHeight}px`;
    getEls(".tabbed-content .tab, .tabbed-content .content").forEach((el) => {
      el.classList.remove("active");
    });

    setTimeout(() => {
      tabEl.classList.add("active");
      if (selectedEl && selectedEl.classList) {
        selectedEl.classList.add("active");
      }
      contentsEl.style.minHeight = "unset";
      trackEvent("ViewContent");
    }, 200);

    if (willAnchor) {
      const offset = getEl(".contents").getBoundingClientRect().top;
      const navHeight = get(this, "props.navHeight", 50);

      if (offset < navHeight) {
        const scrollY =
          window.pageYOffset || document.documentElement.scrollTop;

        window.scrollTo(0, scrollY + offset - navHeight);
      }
    }

    this.setState({ selectedKey });
    if (!replaceState) return;
    if (typeof window === "undefined") return;
    window.history.replaceState({}, slug, `${replaceState}${slug}`);
  };

  render() {
    if (typeof window === "undefined") return null;
    const selectedKey = this.state.selectedKey || 0;
    const data = JSON.parse(this.props.data);
    const tabs = [];
    const contents = [];
    const expectedComponents = {
      Gallery: Gallery,
      Rooms: Rooms,
      Privacy: Privacy,
      TermsCancun: TermsCancun,
      TermsCancun2020: TermsCancun2020,
      TermsMaui: TermsMaui,
      TermsMaui2019: TermsMaui2019,
      TermsMaui2021: TermsMaui2021,
      TermsMaui2021v2: TermsMaui2021V2,
      TermsKauai2019: TermsKauai2019,
      TermsKauai2021: TermsKauai2021,
      TermsCancun2021: TermsCancun2021,
    };

    data.forEach((tab) => {
      const classList = [];
      const { key } = tab;
      const isHidden = tab.hideTab;
      const isActive = key === selectedKey;

      if (isActive) classList.push("active");
      if (isHidden) classList.push("hidden");
      tabs.push(
        <div
          key={`${tab.name}-name-${key}`}
          data-slug={tab.slug || ""}
          className={[...classList, "tab"].join(" ")}
          onClick={isActive ? undefined : this.selectTab(tab.key)}
        >
          {tab.name}
        </div>
      );
      if (tab.component) {
        const Component = expectedComponents[tab.component];

        contents.push(
          <div
            key={`${tab.name}-component-${key}`}
            className={[...classList, "content"].join(" ")}
          >
            <Component inherit={tab.props} />
          </div>
        );
      } else if (tab.body) {
        contents.push(
          <div
            key={`${tab.name}-body-${key}`}
            className={[...classList, "content"].join(" ")}
            dangerouslySetInnerHTML={{ __html: tab.body }}
          />
        );
      }
    });
    return (
      <div className="tabbed-content">
        <div className="header">
          {this.props.title ? <h1>{this.props.title}</h1> : ""}
          <div className="tabs">
            <div className="wrap">{tabs}</div>
          </div>
        </div>
        <div className="bookmark" id="content" />
        <div className="contents wrap">{contents}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/tabbed-content.js